/**
 * Announcement Bar - Управление фиксированным баром
 * Улучшенная версия с правильной работой высоты и состояний
 */

document.addEventListener('DOMContentLoaded', function() {
  const barSection = document.querySelector('.announcement-bar-section');
  const closeBtn = document.querySelector('.announcement-bar__close');

  if (!barSection) return; // если нет панели, прекращаем работу

  // Функция для обновления высоты бара
  function updateBarHeight() {
    if (barSection.style.display === 'none') {
      document.documentElement.style.setProperty('--announcement-bar-height', '0px');
      document.body.style.paddingTop = '0px';
    } else {
      const barHeight = barSection.offsetHeight;
      document.documentElement.style.setProperty('--announcement-bar-height', `${barHeight}px`);
      document.body.style.paddingTop = `${barHeight}px`;
    }
  }

  // Функция для скрытия бара
  function hideBar() {
    barSection.style.display = 'none';
    document.documentElement.style.setProperty('--announcement-bar-height', '0px');
    document.body.style.paddingTop = '0px';
    document.body.classList.add('announcement-bar-hidden');
    document.documentElement.classList.add('announcement-bar-was-closed'); // Добавляем класс к HTML
    
    // Header должен прилипать к верху когда бар скрыт
    const header = document.querySelector('.shopify-section-header, .header-section');
    if (header) {
      header.style.top = '0';
    }
    
    // Мобильное меню тоже на полную высоту
    const drawer = document.querySelector('.header__drawer, .menu-drawer');
    if (drawer) {
      drawer.style.top = '0';
      drawer.style.height = '100vh';
    }
  }

  // Функция для показа бара
  function showBar() {
    barSection.style.display = 'block';
    document.body.classList.remove('announcement-bar-hidden');
    
    // Небольшая задержка чтобы браузер пересчитал высоту
    setTimeout(() => {
      updateBarHeight();
      
      // Header возвращаем под бар
      const barHeight = barSection.offsetHeight;
      const header = document.querySelector('.shopify-section-header, .header-section');
      if (header) {
        header.style.top = `${barHeight}px`;
      }
      
      // Мобильное меню тоже
      const drawer = document.querySelector('.header__drawer, .menu-drawer');
      if (drawer) {
        drawer.style.top = `${barHeight}px`;
        drawer.style.height = `calc(100vh - ${barHeight}px)`;
      }
    }, 10);
  }

  // Проверяем, закрывал ли пользователь панель ранее
  const barClosed = localStorage.getItem('announcementBarClosed');
  if (barClosed === 'true') {
    hideBar();
  } else {
    showBar();
  }

  // Обработчик клика по кнопке закрытия
  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      hideBar();

      // Записываем состояние в localStorage
      localStorage.setItem('announcementBarClosed', 'true');

      // (Опционально) дублируем состояние в cookie
      const expires = new Date();
      expires.setDate(expires.getDate() + 30); // срок жизни 30 дней
      document.cookie = 'announcementBarClosed=true; path=/; expires=' + expires.toUTCString();
    });
  }

  // Обновляем высоту при изменении размера окна
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      if (barSection.style.display !== 'none') {
        updateBarHeight();
      }
    }, 250);
  });

  // Обновляем высоту после полной загрузки страницы (на случай если шрифты загрузились поздно)
  window.addEventListener('load', () => {
    if (barSection.style.display !== 'none') {
      updateBarHeight();
    }
  });

  // Дополнительно: если announcement bar использует слайдер (swiper/flickity)
  // обновляем высоту после инициализации слайдера
  const observer = new MutationObserver(() => {
    if (barSection.style.display !== 'none') {
      updateBarHeight();
    }
  });
  
  observer.observe(barSection, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style']
  });

  // Экспортируем функции для возможного использования в других скриптах
  window.announcementBarAPI = {
    hide: hideBar,
    show: showBar,
    updateHeight: updateBarHeight
  };
});

/* #9 — expose live header height as a CSS var for drawer max-height,
   and ensure body scroll-lock never freezes the drawer's own scroll. */
(function () {
  function setHeaderHeight() {
    var header = document.querySelector('.section-header, #shopify-section-sticky-header, header');
    if (header) {
      document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
    }
  }
  window.addEventListener('load', setHeaderHeight);
  window.addEventListener('resize', setHeaderHeight);
  FoxTheme && FoxTheme.DOMready ? FoxTheme.DOMready(setHeaderHeight) : document.addEventListener('DOMContentLoaded', setHeaderHeight);
})();

/* #6 — mobile menu accordion: opening one parent closes its siblings */
(function () {
  function initMenuAccordion() {
    var drawer = document.querySelector('menu-drawer');
    if (!drawer) return;
    drawer.addEventListener('click', function (event) {
      var summary = event.target.closest('summary');
      if (!summary) return;
      var details = summary.parentElement;
      if (!details || details.getAttribute('is') !== 'menu-drawer-details') return;
      /* Only enforce one-open-at-a-time for LEVEL-2 accordions, not the
         level-1 slide-in panels (which already show one panel at a time). */
      if (details.getAttribute('level') === 'top') return;
      /* Each <details> is wrapped in its own <li>, so siblings live on the <li>
         level — walk the parent <ul>'s <li> children. After the base component's
         100ms setTimeout adds .active to the just-opened item, close the others. */
      var li = details.closest('li');
      if (!li || !li.parentElement) return;
      setTimeout(function () {
        /* The base onSummaryClick only ever ADDS .active (close was designed for the
           now-hidden back button). If the user just COLLAPSED this item (native open
           is false), clear its .active state so the +/- indicator and CSS stay in sync. */
        if (!details.open) {
          if (typeof details.onCloseButtonClick === 'function') details.onCloseButtonClick();
          return;
        }
        Array.prototype.forEach.call(li.parentElement.children, function (sibLi) {
          if (sibLi === li || !sibLi.querySelector) return;
          var sib = sibLi.querySelector(':scope > details[is="menu-drawer-details"]');
          if (sib && sib.classList.contains('active') && typeof sib.onCloseButtonClick === 'function') {
            /* Reuse the component's own close path — removes .active, flips
               aria-expanded, and collapses the accordion via max-height. */
            sib.onCloseButtonClick();
          }
        });
      }, 120);
    });
  }
  if (typeof FoxTheme !== 'undefined' && FoxTheme.DOMready) {
    FoxTheme.DOMready(initMenuAccordion);
  } else {
    document.addEventListener('DOMContentLoaded', initMenuAccordion);
  }
})();

/* Mobile bottom nav: route the Catalog and Cart taps to the existing header
   drawers by clicking their real toggles (reuses the wired open logic). */
(function () {
  function clickToggle(selector) {
    var el = document.querySelector(selector);
    if (el) {
      el.click();
      return true;
    }
    return false;
  }
  function initBottomNav() {
    var nav = document.querySelector('.mobile-bottom-nav');
    if (!nav) return;
    nav.addEventListener('click', function (event) {
      if (event.target.closest('[data-open-menu-drawer]')) {
        event.preventDefault();
        clickToggle('[aria-controls="MenuDrawer"]');
        return;
      }
      if (event.target.closest('[data-open-cart-drawer]')) {
        event.preventDefault();
        if (!clickToggle('[aria-controls="CartDrawer"]')) {
          var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          window.location.href = root + 'cart';
        }
        return;
      }
    });
  }
  if (typeof FoxTheme !== 'undefined' && FoxTheme.DOMready) {
    FoxTheme.DOMready(initBottomNav);
  } else {
    document.addEventListener('DOMContentLoaded', initBottomNav);
  }
})();
